import { storyblokEditable } from 'lib/storyblok/storyblokEditable'
import { RichTextHighlightCardStoryblok } from 'lib/storyblok/types'
import { textByLine } from 'lib/utils/content'

import { StoryblokCallToAction } from '../StoryblokCallToAction'
import { StoryblokImage } from '../StoryblokImage'

type Props = {
  block: RichTextHighlightCardStoryblok
}

export const RichTextHighlightCard = ({ block }: Props) => {
  const { title, description, ctas, image } = block

  return (
    <div className="w-full text-foreground py-10 px-5 md:px-0">
      <div
        className="flex flex-col md:flex-row mx-auto max-w-rich-text bg-foreground/5 rounded-4"
        {...storyblokEditable(block)}
      >
        <div className="flex flex-col gap-6 p-5 md:p-8">
          <div className="flex flex-col gap-2.5">
            <p className="text-title-small md:text-title-medium font-regular">
              {title}
            </p>
            {textByLine(description, (part) => (
              <p className="text-eighteen md:text-twenty/normal">{part}</p>
            ))}
          </div>
          {ctas && ctas.length > 0 && (
            <div className="flex gap-3">
              {ctas.map((cta) => (
                <StoryblokCallToAction cta={cta} key={cta._uid} />
              ))}
            </div>
          )}
        </div>
        {image && (
          <div className="p-2">
            <div className="relative overflow-hidden w-full md:min-w-[251px] h-[251px] md:h-full rounded-3">
              <StoryblokImage
                fill
                asset={image}
                width={undefined}
                height={undefined}
                className="object-cover"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
